import type { ReactNode } from 'react';
import { useState } from 'react';
import type { BreadcrumbsProps } from '@/components/ui/breadcrumbs';
import { PageHeaderContext } from './page-header.context';

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeader] = useState<BreadcrumbsProps | null>(null);

  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
}
